export default __webpack_public_path__ + "static/media/image40.a35320ba.svg";